const version_check_modal = {
  title: 'Nouvelle mise à jour disponible !',
  description:
    "Nous avons apporté des améliorations et ajouté de nouvelles fonctionnalités pour améliorer votre expérience. Mettez à jour l'app pour profiter pleinement de l'application !",
  cta: 'Mettre à jour maintenant',
}

export default version_check_modal
